import React, { useState, useEffect, useContext } from 'react';
import { Redirect } from 'react-router';
import { useHistory } from 'react-router-dom';

import { useForm, Controller } from 'react-hook-form';

import useToast from 'components/Additional/Toast/useToast';
import PageTitle from 'components/Additional/PageElements/PageTitle/PageTitle';
import Footer from 'components/Additional/Footer/Footer';
import BottomNavigation from 'components/Additional/BottomNavigation/BottomNavigation';
import CustomCheckbox from 'components/Additional/CustomCheckbox/CustomCheckbox';
import DidYouKnow from 'components/Additional/DidYouKnow/DidYouKnow';

import { updateQuote, createActivityQuoteDB } from '../API/Model';
import { AppContext } from 'context/app-context/AppContext';
import Navigation from '../Overlays/Navigation';
import { updateDiscounts } from 'tools/CreateQuoteHelper';
import { saveDiscountsData } from 'tools/LocalStorageHelper';

import './Discounts_page.css';
import 'components/styles/styles.css';

function Discounts_page() {
	const PAGE_NAME = 'Discounts';
	const page = 3;
	let history = useHistory();

	const { fetchQuoteAndLog } = useContext(AppContext);
	const {
		control,
		formState: { errors },
		handleSubmit,
		setValue,
	} = useForm({
		shouldUnregister: false,
		defaultValues: {
			militaryDiscount: false,
			years54Discount: false,
			gatedCommunityDiscount: false,
			alarmDiscount: false,
			alarmDiscount: false,
			waterDiscount: false,
			shutterDiscount: false,
		},
	});

	const [quote_information, setquote_information] = useState(0);
	const [submitLoading, setsubmitLoading] = useState(false);
	const [load, setonLoad] = useState(false);

	useEffect(() => {
		async function fetchData() {
			const response = await fetchQuoteAndLog(PAGE_NAME);
			setquote_information({
				ExternalValidateBeanExist: 'No',
				DTOApplication: [response],
			});
		}

		(async () => {
			await fetchData();
		})();
	}, []);

	useEffect(() => {
		if (quote_information.ExternalValidateBeanExist != undefined) {
			if (load === false) {
				createActivityQuoteDB(
					'Discounts',
					'PL',
					'Discounts page loaded'
				);
				localStorage.setItem('current_page', 'Discounts');

				try {
					setValue(
						'militaryDiscount',
						quote_information.DTOApplication[0].DTOLine[0]
							.MilitaryFirstResponderInd === 'Yes'
					);
					setValue(
						'years54Discount',
						calculateAge(
							quote_information.DTOApplication[0].DTOInsured[0]
								.PartyInfo[0].PersonInfo[0].BirthDt
						) > 54
					);
					setValue(
						'gatedCommunityDiscount',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].GateGuarded ===
							'Single Entry or 24 hr Patrol'
					);
					setValue(
						'alarmDiscount',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].BurglarAlarmCd ===
							'Central Monitoring Station'
					);
					setValue(
						'waterDiscount',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].WaterMonitoringSystem ===
							'Water Detection Device with Automatic Shut-Off'
					);
					setValue(
						'shutterDiscount',
						quote_information.DTOApplication[0].DTOLine[0]
							.DTORisk[0].DTOBuilding[0].OpeningProtection ===
							'Hurricane'
					);
				} catch (e) {
					console.log('Error with fetching discount information');
				}

				setonLoad(true);
			}
		}
	}, [quote_information]);

	useEffect(() => {
		console.log('errors', errors);
	}, [errors]);

	const validateAndSubmit = async (event) => {
		handleSubmit(onSubmit)();
	};

	function calculateAge(date) {
		const year = parseInt(date.substring(0, 4), 10);
		const month = parseInt(date.substring(4, 6), 10) - 1;
		const day = parseInt(date.substring(6, 8), 10);

		const today = new Date();
		const dob = new Date(year, month, day);

		let age = today.getFullYear() - dob.getFullYear();

		const beforeBd =
			today.getMonth() < dob.getMonth() ||
			(today.getMonth() === dob.getMonth() &&
				today.getDate() < dob.getDate());

		if (beforeBd) {
			age--;
		}

		return age;
	}

	const onSubmit = async (data) => {
		setsubmitLoading(true);
		createActivityQuoteDB('Discounts', 'NAV', 'Continue button');
		saveDiscountsData(data);

		const quoteType =
			quote_information.DTOApplication[0].DTOBasicPolicy[0].SubTypeCd;
		updateDiscounts(quote_information, data, quoteType);

		createActivityQuoteDB(
			'Discounts',
			'API_REQ',
			'Discounts update quote request'
		);

		const quoteInformationString = JSON.stringify(quote_information);
		const response = await updateQuote(quoteInformationString);
		createActivityQuoteDB(
			'Discounts',
			'API_RES',
			'Discounts update quote response - ' + response
		);

		history.push('/Coverages');
	};

	function onBackButtonClick() {
		createActivityQuoteDB('Discounts', 'NAV', 'Back button');
	}

	if (localStorage.getItem('status') === 'COMP') {
		return <Redirect push to={'/Coverages'} />;
	} else {
		return (
			<div className="base-wrapper">
				<div className="abs-wrapper">
					<Navigation page={page} progress={3} />
				</div>
				{submitLoading ? (
					<DidYouKnow title="Calculating your estimate" />
				) : load === false ? (
					<DidYouKnow title="Updating your estimate" />
				) : (
					<div className="discounts_wrapper">
						<div className="discounts_content_wrapper">
							<div>
								<PageTitle titleContent={<>Discounts</>} />
								<form onSubmit={validateAndSubmit}>
									<div
										className={`contentBox_p${
											localStorage.getItem(
												'policy_type'
											) === 'HO3'
												? '5'
												: localStorage.getItem(
														'policy_type'
												  ) === 'DF1'
												? '7'
												: '6'
										}`}
									>
										<div className="p4_c1_rn">
											Review the below statements and
											select all that apply:
										</div>
										<div className="p4_c2_rn"></div>
										{localStorage.getItem('policy_type') ===
											'HO3' && (
											<>
												<div className="p4_c1_r0">
													I am active-duty military, a
													veteran, or a first
													responder.
												</div>
												<div className="p4_c2_r0 checkbox_container">
													<Controller
														name="militaryDiscount"
														control={control}
														render={({
															value,
															onChange,
														}) => (
															<CustomCheckbox
																id="militaryDiscount"
																value={value}
																onChange={
																	onChange
																}
															/>
														)}
													/>
												</div>
											</>
										)}
										<div className="p4_c1_r1">
											I am over the age of 54.
										</div>
										<div className="p4_c2_r1 checkbox_container">
											<Controller
												name="years54Discount"
												control={control}
												render={({
													value,
													onChange,
												}) => (
													<CustomCheckbox
														id="years54Discount"
														value={value}
														onChange={onChange}
													/>
												)}
											/>
										</div>
										{localStorage.getItem('policy_type') !==
											'DF1' && (
											<>
												<div className="p4_c1_r2">
													I live in a gated community.
												</div>
												<div className="p4_c2_r2 checkbox_container">
													<Controller
														name="gatedCommunityDiscount"
														control={control}
														render={({
															value,
															onChange,
														}) => (
															<CustomCheckbox
																id="gatedCommunityDiscount"
																value={value}
																onChange={
																	onChange
																}
															/>
														)}
													/>
												</div>
											</>
										)}
										<div className="p4_c1_r3">
											My home is equipped with one or more
											of the following: fire alarm, home
											sprinkler system, burglar alarm.
										</div>
										<div className="p4_c2_r3 checkbox_container">
											<Controller
												name="alarmDiscount"
												control={control}
												render={({
													value,
													onChange,
												}) => (
													<CustomCheckbox
														id="alarmDiscount"
														value={value}
														onChange={onChange}
													/>
												)}
											/>
										</div>
										{(localStorage.getItem(
											'policy_type'
										) === 'HO3' ||
											localStorage.getItem(
												'policy_type'
											) === 'HO5') && (
											<>
												<div className="p4_c1_r4">
													My home is equipped with a
													water leak detection device,
													such as an automatic shut
													off device.
												</div>
												<div className="p4_c2_r4 checkbox_container">
													<Controller
														name="waterDiscount"
														control={control}
														render={({
															value,
															onChange,
														}) => (
															<CustomCheckbox
																id="waterDiscount"
																value={value}
																onChange={
																	onChange
																}
															/>
														)}
													/>
												</div>
											</>
										)}
										<div className="p4_c1_r5">
											My home is equipped with storm
											shutters.
										</div>
										<div className="p4_c2_r5 checkbox_container">
											<Controller
												name="shutterDiscount"
												control={control}
												render={({
													value,
													onChange,
												}) => (
													<CustomCheckbox
														id="shutterDiscount"
														value={value}
														onChange={onChange}
													/>
												)}
											/>
										</div>

										<div className="footer">
											<BottomNavigation
												backPath="/PropertyInfo"
												backButtonOnClick={
													onBackButtonClick
												}
												nextButtonType="submit"
												nextButtonDisabled={false}
											/>
										</div>
									</div>
								</form>
							</div>
							<Footer />
						</div>
					</div>
				)}
			</div>
		);
	}
}

export default Discounts_page;
